import React from "react";
import { Box, Text } from "@chakra-ui/react";

const ReportCN = ({ content }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="400px"
      bg="gray.50"
      borderRadius="md"
      border="2px"
      borderColor="gray.300"
    >
      <Text fontSize="xl" color="gray.500">
        CN Reports - Coming Soon
      </Text>
    </Box>
  );
};

export default ReportCN;
